module.exports = new __parcel__URL__("foundational-blue-work-management.260d07fb.png").toString();